class CapsuleProductInfoSlider extends HTMLElement {
    constructor() {
        super();
        this.flkty = null;
        this.initialized = false;
        this.mql = window.matchMedia('(max-width: 768px)');
        this.onMediaChange = this.onMediaChange.bind(this);
    }

    connectedCallback() {
        const itemsCount = this.getAttribute('data-items-count');
        if (itemsCount && itemsCount <= 1) {
            return;
        }

        this.mql.addEventListener('change', this.onMediaChange);
        if (this.mql.matches) {
            this.initSlider();
        }
    }

    disconnectedCallback() {
        this.mql.removeEventListener('change', this.onMediaChange);
        this.destroySlider();
    }

    onMediaChange(event) {
        if (event.matches) {
            this.initSlider();
        } else {
            this.destroySlider();
        }
    }

    initSlider() {
        if (this.initialized) return;

        const Flickity = window.theme && window.theme.Flickity;
        if (!Flickity) {
            return;
        }

        const slides = this.querySelectorAll('[data-capsule-slide]');
        if (!slides.length) return;

        this.initialized = true;
        this.flkty = new Flickity(this, {
            cellSelector: '[data-capsule-slide]',
            cellAlign: 'left',
            contain: true,
            draggable: true,
            prevNextButtons: false,
            pageDots: false,
            setGallerySize: false,
        });
    }

    destroySlider() {
        if (this.flkty && typeof this.flkty.destroy === 'function') {
            this.flkty.destroy();
        }
        this.flkty = null;
        this.initialized = false;
    }
}

if (!customElements.get('capsule-product-info-slider')) {
    customElements.define('capsule-product-info-slider', CapsuleProductInfoSlider);
}
